import { NgModule, CUSTOM_ELEMENTS_SCHEMA } from '@angular/core';
import { CommonModule } from '@angular/common';
import { CoreModule } from '@core/core.module';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { AppRouterModule } from '@app/router.module';
import { HelpersEditorModule } from '@core/components/helpers/editor/editor.module';


import { SettingsUsersMainComponent } from './main/main.component';
import { SettingsUsersInvitationsAddComponent } from './invitations-add/invitations-add.component';
import { SettingsUsersListUsersComponent } from './list-users/list-users.component';
// import { SettingsUsersInfoUserComponent } from './info-user/info-user.component';
import { SettingsManageUsersAddComponent } from './main-add/main-add.component';
import { SettingsUsersInfoUserSeatComponent } from './info-user-seat/info-user-seat.component';



@NgModule({
    imports: [
        CoreModule,
        CommonModule,
        AppRouterModule,
        FormsModule,
        ReactiveFormsModule,
        HelpersEditorModule
    ],
    schemas: [ CUSTOM_ELEMENTS_SCHEMA ],
    declarations: [
        SettingsUsersMainComponent,
		SettingsUsersInvitationsAddComponent,
        SettingsUsersListUsersComponent,
        // SettingsUsersInfoUserComponent,
        SettingsManageUsersAddComponent,
        SettingsUsersInfoUserSeatComponent
    ],
    exports: [
        SettingsUsersMainComponent,
		SettingsUsersInvitationsAddComponent,
        SettingsUsersListUsersComponent,
        // SettingsUsersInfoUserComponent,
        SettingsUsersInfoUserSeatComponent,
        SettingsManageUsersAddComponent
    ],

})
export class SettingsUsersModule { }
